import { ArrayHelper, DynamicTableHelper } from "@workspace/common";

const ACCOUNT_MANDATORY_OPTIONS = [
  {
    sortValue: "account_submission_data.accountId",
    label: "Pulse Account Id",
    value: "accountSubmissionData.accountId",
    sort: true,
    expand: true,
  },
  {
    label: "Account Number",
    value: "accountNumber",
    sort: true,
    sortValue: "account_submission_data.accountNumber",
  },
  {
    label: "Account Name",
    value: "accountSubmissionData.accountName",
    sort: true,
    sortValue: "account_submission_data.accountName",
    expand: true,
  },
];

const ACCOUNT_INITIAL_OPTIONS = [
  {
    label: "Account Source",
    value: "accountSubmissionData.accountSource",
    sort: true,
    sortValue: "account_submission_data.accountSource",
  },
  {
    label: "Account Owner",
    value: "accountSubmissionData.accountOwner",
    sort: true,
    sortValue: "account_submission_data.accountOwner",
  },
  {
    label: "Secondary Owner",
    value: "accountSubmissionData.secondaryOwner",
    sort: true,
    sortValue: "account_submission_data.secondaryOwner",
  },
  {
    label: "Created By",
    value: "createdByName",
    sort: true,
    sortValue: "createdByName",
  },
  {
    label: "Parent Account",
    value: "accountSubmissionData.parentCompany",
    sort: true,
    sortValue: "account_submission_data.parentCompany",
  },
  {
    label: "Account Status",
    value: "accountSubmissionData.accountStatus",
    sort: true,
    sortValue: "account_submission_data.accountStatus",
  },
];

const ACCOUNT_MAIN_FIELDS = [
  {
    label: "Created By",
    value: "createdByName",
    sort: true,
    sortValue: "createdByName",
  },
  {
    label: "Updated By",
    value: "updatedByName",
    sort: true,
    sortValue: "updatedByName",
  },
  {
    label: "Account Country",
    value: "accountCountry",
    sort: true,
    sortValue: "account_country",
  },
  {
    label: "Created At",
    value: "createdAt",
    sort: true,
    sortValue: "created_at",
  },
  {
    label: "Updated At",
    value: "updatedAt",
    sort: true,
    sortValue: "updated_at",
  },
];

const generateAccountFields = (accountForm, commercialForm) => {
  const fields = [...ACCOUNT_MAIN_FIELDS];

  if (accountForm) {
    const accountOptions = DynamicTableHelper.buildOptionsArray(
      accountForm?.formSchema,
      "accountSubmissionData",
      "account_submission_data",
      "Account"
    );
    fields.push(...accountOptions);
  }

  if (commercialForm) {
    const commercialOptions = DynamicTableHelper.buildOptionsArray(
      commercialForm?.formSchema,
      "commercialSubmissionData",
      "commercial_submission_data",
      "Commercial"
    );
    fields.push(...commercialOptions);
  }

  // Remove duplicate value in the object of array. Keep the first
  const fieldsNew = fields.filter(
    (field, index, self) =>
      index === self.findIndex((t) => t.value === field.value)
  );

  ArrayHelper.sortArrayObjIcase(fieldsNew, "label");

  return fieldsNew;
};

export {
  ACCOUNT_INITIAL_OPTIONS,
  ACCOUNT_MANDATORY_OPTIONS,
  generateAccountFields,
};
